import React from 'react';
import { ServiceForm } from 'shared/ui';
import { BookingApi } from 'shared/api';
import { businessStore } from 'entities/index';
import { IServicesCard } from 'shared/api/booking/interfaces/services-list.interface';

export interface IEditServiceProps {
  serviceInfo: IServicesCard;
  onClose?: () => void;
  onSuccess?: (message: string) => void;
  onDuplicate?: (service: IServicesCard) => void;
}

export const EditService: React.FC<IEditServiceProps> = ({
  serviceInfo,
  onClose,
  onSuccess,
  onDuplicate,
}) => {
  const pointId = businessStore.pointId;

  const handleSubmit = async (data: any) => {
    if (!pointId) return;
    await BookingApi.editService({ ...data, id: serviceInfo.id });
    businessStore.initServicesList(pointId);
    onSuccess?.('Услуга успешно изменена');
    onClose?.();
  };

  const handleDelete = async () => {
    if (!pointId) return;
    await BookingApi.deleteService({ serviceId: serviceInfo.id });
    businessStore.initServicesList(pointId);
    onSuccess?.('Услуга успешно удалена');
    onClose?.();
  };

  return (
    <ServiceForm
      initialData={serviceInfo}
      onSubmit={handleSubmit}
      onDelete={handleDelete}
      onClose={onClose}
      onDuplicate={() => {
        onDuplicate?.(serviceInfo);
        onClose?.();
      }}
    />
  );
};
